<template>
<div class="mb-4" :class="single ? 'col-md-6' : 'col-md-12'" v-if="modules.length > 0 && $acl['employee/bulk'] == 2">
  <div class="clearfix company-form-container h-100 mb-3">
    <div class="row no-gutters py-2 border-bottom">
          <div class="col-sm-6 px-3 company-form-box-title">Approver</div>
          <div class="col-sm-6 px-3 cursor-pointer text-right company-form-box-title" v-if="current_module > 0" @click="addSelect()"><button class="edit-icon"><i class="fa fa-plus"></i></button></div>
      </div>

      <b-overlay :show="showoverlay_list" rounded="sm">


      <div class="p-2">
        <b-form-group id="approvers_depth-group" label="Module" label-for="approvers_depth">
            <b-form-select id="approvers_depth" name="approvers_depth" @input="getSelect" v-model="current_module" :options="modules"></b-form-select>
        </b-form-group>
      </div>

        <ul class="bank-info mt-2">
          <li class="m-0 px-4 py-2" v-for="(item, index) in selects" :key="index">
            <div class="title px-0">Level {{ index + 1 }} Approver:</div>
            <div class="text">
                <roster-searchable-select :exclude="excludeList" :searchQuery="item" department="" @update="updateSelect(index, $event)" ></roster-searchable-select>
            </div>
            <div class="action" >
              <b-button-toolbar class="float-right position-relative">
                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                  <b-button-group class="mt-n2">

                      <b-button class="border-0 rounded py-0" variant="outline-secondary" title="Delete Approver" @click="removeSelect(index)">
                          <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                      </b-button>
                  </b-button-group>
                </div>
              </b-button-toolbar>
            </div>
          </li>

        </ul>

        <div class="p-4 d-flex justify-content-end">
            <b-button type="submit" class="border rounded " variant="success" @click="saveSelect" v-if="show_save">Save</b-button>
        </div>
      </b-overlay>

  </div>
</div>

</template>

<script>
export default {
  props: ['single' , 'employee_ids'],
  data() {
    return {
      show_save: false,
      showoverlay_list: false,
      selects: [],
      approver_list: [],
      exclude:[],
      modules : [],
      current_module:0,
    };
  },
  methods: {
    getSettings() {
      Promise.all([
        axios.get(this.$api_url + '/leave-attendance/approver/settings/1'),
        axios.get(this.$api_url + '/leave-attendance/approver/settings/2')
      ]).then(([mod1, mod2]) => {
        if (mod1.data['status'] == 1) {
          this.modules.push({ value: 1, text: 'Leave' });
        }

        if (mod2.data['status'] == 1) {
          this.modules.push({ value: 2, text: 'Attendance' });
        }

        if (this.modules.length > 0) {
          this.current_module = this.modules[0].value;
          this.getSelect();
        }
      });
    },
    addSelect() {
      this.show_save = true;
      this.selects.push({ value: '', text: '' });
    },
    removeSelect(index) {
      this.show_save = true;
      this.selects.splice(index, 1);
    },
    updateSelect(index, newValue) {
      this.selects[index] = newValue;
    },
    getSelect() {
      this.show_save = false;
      this.approver_list = [];
      axios.get(this.$api_url + '/leave-attendance/approver/list/'+this.current_module).then(response => {
                this.selects = response.data;
                this.approver_list = response.data;
            }).catch(error => {
                this.serverError(error);
            });
    },
    saveSelect() {

        let empty = this.selects.filter(({value}) => value == '');
        if(empty.length > 0){
          this.$bvToast.toast('Incorrect Employee Selected',{
            solid: true,
            title: 'Failed',
            variant: 'danger',
          });
          return;
        }

        let valuesToSend = this.selects.map(item => item.value);
        this.showoverlay_list = true;
        let formData = new FormData();
        formData.append('selects', JSON.stringify(valuesToSend));
        formData.append('employee_ids', JSON.stringify(this.employee_ids));

        axios.post(this.$api_url + '/leave-attendance/approver/list/'+this.current_module, formData).then(response => {

            this.$bvToast.toast('Saved!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });
            this.showoverlay_list = false;

            this.$emit('event');


        }).catch(error => {

            this.serverError(error);
        });

    },
  },
  created() {
    this.getSettings();
      // if(this.single)
      //   this.getSelect();
    },
  computed: {

    excludeList() {
      let selects = this.selects.filter(s => s.value).map(s => s.value);
      return selects.concat(this.employee_ids);
    }
  },
};
</script>
